import { Skeleton } from "@material-ui/lab";
import { Div, LoadingContainer } from "./style";

const LoadingImg = (props) => {
  const { isLoading } = props;

  return (
    <>
      <LoadingContainer isLoading={isLoading}>
        <Div className="d-flex justify-content-center">
          <Skeleton
            variant="circle"
            animation="wave"
            width={100}
            height={100}
          />
        </Div>
      </LoadingContainer>
    </>
  );
};

export default LoadingImg;
